module.exports = __webpack_public_path__ + "img/swaptimes.9f0e3464.png";